import React from 'react'
import {
    Card
} from 'semantic-ui-react'


const LibraryAppList = (props) => {
    const { appList } = props;

    return (
        <>
            <Card.Group centered>
                {appList.map((app) => {
                    return (
                        <Card
                            className='app-card-container'
                            key={app.id}
                            //onClick={() => this.setState({ detailModalVisibility: true,selectedApp:appList[app]})}
                            onClick={() => props.onOpenAppDetail(app)}
                        >
                            <Card.Content>
                                <div className='device-card'>
                                    <div>
                                        <img
                                            style={{ objectFit: 'contain', height: 72, background: 'white' }}
                                            loading='lazy'
                                            src={'data:image/png;base64,' + app.icon}
                                            alt='deviceImage'
                                        />
                                    </div>
                                    <div
                                        className='device-card-content'
                                        style={{ minHeight: 85 }}
                                    >
                                        <div className='device-card-name'>
                                            {app.name}
                                        </div>

                                        <span style={{ color: 'black' }}>
                                            {app.os}
                                        </span>

                                        <span style={{ color: 'black' }}>
                                            {app.packageName}
                                        </span>
                                    </div>
                                </div>
                            </Card.Content>
                        </Card>);
                })}
            </Card.Group>
        </>
    )
}

export default LibraryAppList